import { useEffect, useRef, useState } from "react";
import './styles.css';
const SearchableDropdown = ({
    options,
    label,
    id,
    selectedVal,
    name,
    handleChange,
    placeholder,
    isError
}) => {
    const [query, setQuery] = useState("");
    const [isOpen, setIsOpen] = useState(false);

    const inputRef = useRef(null);

    useEffect(() => {
        console.log('isError', isError, placeholder);
        document.addEventListener("click", toggle);
        return () => document.removeEventListener("click", toggle);
    }, []);

    const selectOption = (option) => {
        setQuery(() => "");
        handleChange(option[label]);
        setIsOpen((isOpen) => !isOpen);
    };

    function toggle(e) {
        setIsOpen(e && e.target === inputRef.current);
    }

    const getDisplayValue = () => {
        if (query) return query;
        if (selectedVal) return selectedVal;

        return "";
    };

    const filter = (options) => {
        return options.filter(
            (option) => option[label].toLowerCase().indexOf(query.toLowerCase()) > -1
        );
    };

    return (
        <div className="dropdown">
            <span style={{ color: isError ? '#ff715b' : '#495057' }}>{name}</span>
            <div className="control mt-2 mb-1">
                <div className="selected-value">
                    <input
                        className="form-control"
                        style={{ border: isError ? '1px solid #ff715b' : '1px solid #ced4da' }}
                        ref={inputRef}
                        type="text"
                        placeholder={placeholder}
                        value={getDisplayValue()}
                        name="searchTerm"
                        onChange={(e) => {
                            setQuery(e.target.value);
                            handleChange(null);
                        }}
                        onClick={toggle}
                    />
                </div>
                <div className={`arrow ${isOpen ? "open" : ""}`} style={{ marginTop: 35 }}></div>
            </div>
            {isError &&
                <span style={{ color: '#ff715b', fontSize:12, marginTop:30 }}>This field is invalid</span>
            }
            <div className={`options ${isOpen ? "open" : ""}`}>
                {filter(options).map((option, index) => {
                    return (
                        <div
                            onClick={() => selectOption(option)}
                            className={`option ${option[label] === selectedVal ? "selected" : ""
                                }`}
                            key={`${id}-${index}`}
                        >
                            {option[label]}
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default SearchableDropdown;